import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'googleButton', 'microsoftButton', 'submitButton']
  connect () {
    this.checkboxTarget.addEventListener('change', this.#manageButtonsState.bind(this))
  }

  #manageButtonsState () {
    if (this.checkboxTarget.checked) {
      this.googleButtonTarget.disabled = false
      this.microsoftButtonTarget.disabled = false
      this.submitButtonTarget.disabled = false
    } else {
      this.googleButtonTarget.disabled = true
      this.microsoftButtonTarget.disabled = true
      this.submitButtonTarget.disabled = true
    }
  }
}
